import { windowMessageUtil, FROM_TYPE, baseUrlApis } from 'Api/index'
import {getQueryVariable} from 'Utils/utils'
import {store} from 'Store/store.index'
import AIPluginUserFns from './AIPluginUserFns';
import EventManage from './EventManage'
import AIPluginDocFns from './AIPluginDocFns'
import {
  LABEL_TOOL_CANCELED,
  LABEL_TOOL_START,
  LABEL_TOOL_END
} from './constants'

export default class AIPluginController{
  constructor() {
    this.fnMap = {}
    this.isInit = false;
    this.isLoadAiPlugin = false;
    this.params = {targetOrigin:'', url:''};

    this.userFns = new AIPluginUserFns(this.fnMap);
    this.eventManage = new EventManage(this.fnMap);
    this.AiPluginDocFns = new AIPluginDocFns(this.fnMap);

    //this.addFn_loginIn = this.addFn_loginIn.bind(this);
    this.onRequestCallback = this.onRequestCallback.bind(this);
    this.loadAiPlugin = this.loadAiPlugin.bind(this);
    this.releaseAiPlugin = this.releaseAiPlugin.bind(this);
    this.makeAiPluginParams = this.makeAiPluginParams.bind(this);
  }
  releaseAiPlugin(){
    let $$ = window.UIExtension.jQuery;
    const $iframe = $$('.ai-panel iframe');
    $iframe.attr('src', '');
    this.isLoadAiPlugin = false;
  }
  makeAiPluginParams(){
    let origin = baseUrlApis.getBaseOrigin();
    let targetOrigin = '';
    let url = '';
    do {
      const {foxitAiPluginUrl, foxitAiUrl} = store.appStore;
      const { full } = store.appStore.lng;
      //let targetOrigin = foxitAiPluginUrl;
      let v1 = '2.0.0.0';

      if( origin.indexOf('localhost')!== -1 || origin.indexOf('127.0.0.1')!== -1){
        targetOrigin = 'https://127.0.0.1';
      } else if(!!foxitAiPluginUrl){
        targetOrigin = foxitAiPluginUrl;
      } else{
        break;
      }
      let server_config = getQueryVariable('server_config');
      if(!!server_config){
        targetOrigin = foxitAiPluginUrl;
      }
      let useLocalAiPlugin = getQueryVariable('ai_plugin');
      if(useLocalAiPlugin === 'local'){
        targetOrigin = 'https://127.0.0.1';
      }

      // "https://p-demo.foxit.ai/?platform=%s&version=%s&language=%s"
      url = `${targetOrigin}/?origin=${encodeURIComponent(origin)}&platform=PhantomOnline&version=${v1}&language=${full}&ai_domain=${foxitAiUrl}`
      if(!!useLocalAiPlugin){
        url += '&server_config='+server_config + "&ai_plugin="+ useLocalAiPlugin;
      }
      let useJWT = getQueryVariable('jwt');
      if(!!useJWT){
        url += '&jwt=' +useJWT
      }
      let debug = getQueryVariable('debug');
      if(!!debug){
        url += '&debug='+debug;
      }

    } while (false);

    return {targetOrigin, url}
  }
  loadAiPlugin(url){
    let $$ = window.UIExtension.jQuery;
    //const iframe = document.querySelector('.ai-panel iframe');
    const $iframe = $$('.ai-panel iframe');

    

    $iframe.attr('src', url);
    this.isLoadAiPlugin = true;

    //fv--ui-text-selection-tooltip fv__ui-layer left top
    let node = document.querySelector('#pdf-ui');
    const cancelfn = ()=>{
      node.classList.remove('fo-ui-label-tool-start');
    }
    const startFn = ()=>{
      node.classList.add('fo-ui-label-tool-start');
    }
    store.appStore.addAppEventListener(LABEL_TOOL_START, startFn)
    store.appStore.addAppEventListener(LABEL_TOOL_END, cancelfn)
    store.appStore.addAppEventListener(LABEL_TOOL_CANCELED, cancelfn)
  }

  init() {
    if(this.isInit){
      !this.isLoadAiPlugin && (this.loadAiPlugin(this.params.url))
      return
    };
    let params = this.makeAiPluginParams();
    const {targetOrigin, url} = params;
    this.params = params;

    windowMessageUtil.init(this.onRequestCallback, FROM_TYPE.ONLINE, targetOrigin)

    this.userFns.registerFn();
    this.AiPluginDocFns.registerFn();
    this.eventManage.init();
    this.loadAiPlugin(url);
    

    this.isInit = true;
  }
  onRequestCallback(method, data, id, listener){
    return new Promise((resolve)=>{
      const fn = this.fnMap[method];
      if(!fn){
        console.error('TCL: AIPluginController -> not support [method]: ',method, data, id)
        return
      }
      fn({method, data, id, listener, resolve});
    })
  }




}